import React, { useEffect, useRef } from "react";

function safePdfName(title, fileName) {
  const raw = String(fileName || title || "form").trim() || "form";
  const cleaned = raw.replace(/[<>:"/\\|?*]/g, " ").replace(/\s+/g, " ").trim();
  return cleaned.toLowerCase().endsWith(".pdf") ? cleaned : `${cleaned}.pdf`;
}

function GeneratedFormPdfPreview({ pdfUrl, title, fileName, unavailable, onClose, onReady }) {
  const downloadName = safePdfName(title, fileName);
  const isBlob = String(pdfUrl || "").startsWith("blob:");
  const iframeSrc = isBlob ? `${pdfUrl}#navpanes=0` : pdfUrl;

  const onReadyRef = useRef(onReady);
  onReadyRef.current = onReady;

  useEffect(() => {
    if (unavailable && onReadyRef.current) {
      onReadyRef.current();
    }
  }, [unavailable]);

  useEffect(() => {
    return () => {
      if (isBlob && pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [pdfUrl, isBlob]);

  if (!pdfUrl && !unavailable) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.45)",
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 16,
      }}
    >
      <div
        style={{
          width: "95%",
          height: "90%",
          background: "#fff",
          borderRadius: 8,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <div className="d-flex justify-content-between align-items-center p-2 border-bottom">
          <h5 className="m-0">{title || "Form preview"}</h5>
          <button type="button" className="btn btn-danger btn-sm" onClick={onClose}>
            Close
          </button>
        </div>

        {unavailable ? (
          <div className="generated-form-preview-empty">
            <p>This document isn’t available to view right now.</p>
            <p>Please try again later, or ask your administrator if you still need it.</p>
          </div>
        ) : (
          <iframe
            title={downloadName}
            src={iframeSrc}
            onLoad={() => onReady && onReady()}
            onError={() => onReady && onReady()}
            style={{ flex: 1, width: "100%", border: "none" }}
          />
        )}
      </div>
    </div>
  );
}

export default GeneratedFormPdfPreview;
